export { DMS_MODULE } from '../constants';
export const NAME = 'UzavRozpracovanosti';
export const CRUMB_LABEL_KEY = 'setUzaverkaRozprac';

export enum ULOZENI_TYP {
	DETAILNI = 0,
	USPORNE = 1,
}

export const reportUrl = '/Uzaverky/GetUzaverkaRozprac';
